
<div>
  <button class="ui fluid orange huge button" @click="openDialog">
    <slot></slot>
  </button>
  <div :id="dialogId" class="ui small modal">
    <i class="close icon"></i>
    <div class="content" :class="{ scrolling: !done }">
      <form @submit.prevent="post" class="ui form compactMarunageForm" :class="{'success': done, 'warning': form.hasErrors()}">
        <h2 class="compactMarunageForm__title">ケータリングのお問い合わせ</h2>
        <div v-if="done" class="ui success message large">
          このたびはケータリングサービスへのお問い合わせ、誠にありがとうございます。<br>
          担当よりご返信差し上げますので、今しばらくお待ちください。
        </div>
        <div v-else>
          <div class="required field" :class="{'error': form.hasError('name')}">
            <input v-model="form.model.name" type="text" placeholder="お名前(必須)" />
            <validation-message :form="form" field="name" />
          </div>
          <div class="required field" :class="{'error': form.hasError('tel')}">
            <input v-model="form.model.tel" type="text" placeholder="電話番号(半角数字のみ)" />
            <validation-message :form="form" field="tel" />
          </div>
          <div class="required field" :class="{'error': form.hasError('email')}">
            <input v-model="form.model.email" type="text" placeholder="メールアドレス(必須)" />
            <validation-message :form="form" field="email" />
          </div>
          <div class="required field" :class="{'error': form.hasError('destination')}">
            <input v-model="form.model.destination" type="text" placeholder="配送場所(必須)" />
            <validation-message :form="form" field="destination" />
          </div>
          <div class="two fields">
            <div class="required field" :class="{'error': form.hasError('date')}">
              <datepick v-model="form.model.date" :from="1" placeholder="希望日" />
              <validation-message :form="form" field="date" />
            </div>
            <div class="field" :class="{'error': form.hasError('time')}">
              <dropdown v-model="form.model.time" :options="consts.MARUNAGE_EVENT_TIME" placeholder="希望時間" />
              <validation-message :form="form" field="time" />
            </div>
          </div>
          <div class="field" :class="{'error': form.hasError('people')}">
            <input v-model="form.model.people" type="text" placeholder="人数" />
            <validation-message :form="form" field="people" />
          </div>
          <div class="field" :class="{'error': form.hasError('note')}">
            <textarea rows="4" v-model="form.model.note" placeholder="希望条件があればご記入ください。"></textarea>
            <validation-message :form="form" field="note" />
          </div>
          <app-message :msg="form.appMessage"></app-message>
          <div class="field">
            <button class="ui fluid orange button large" :class="{'disabled loading': form.waiting}">送信する</button>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
